import { ColumnState } from 'ag-grid-community';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { UserResponseDto } from 'src/dtos/user/response/userResponseDto';
import { create } from 'zustand';
import { defaultKSK2120_R01Dto, KSK2120_R01Dto } from './Dto_KSK2120_R01';
import { DateRange } from 'react-day-picker';
import { showWarning } from 'src/utils/toast/toastUtil';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import { validateString } from 'src/utils/string/stringUtil';

export interface KSK2120_R01Filter {
	// pastWorkNo: string;
	nowWorkNo: string;
	pastInfoFetch: string;
}

export interface Store_KSK2120_R01 {
	KSK2120_R01Filter: KSK2120_R01Filter;
	KSK2120_R01PastFilter: KSK2120_R01Filter;
	setKSK2120_R01Filter: (filter: Partial<KSK2120_R01Filter>) => void;
	setKSK2120_R01PastFilter: (filter: Partial<KSK2120_R01Filter>) => void;

    KSK2120_R01List: KSK2120_R01Dto[];
    setKSK2120_R01List: (userList: KSK2120_R01Dto[]) => void;
    insertKSK2120_R01List: (data: KSK2120_R01Dto[], index?: number) => void;
    removeKSK2120_R01List: (index: number) => void;
    updateKSK2120_R01List: (index: number, data: KSK2120_R01Dto) => void;

    deletedKSK2120_R01List: string[];
    addDeletedKSK2120_R01List: (idList: string[]) => void;
    removeDeletedKSK2120_R01List: (idList?: string[]) => void;

    selectedKSK2120_R01List: string[];
	setSelectedKSK2120_R01List: (idList: string[]) => void;
    addSelectedKSK2120_R01List: (idList: string[]) => void;
    removeSelectedKSK2120_R01List: (idList?: string[]) => void;
	initSelectedKSK2120_R01List: () => void;
	allSelectedKSK2120_R01List: () => void;

	originalKSK2120_R01List: KSK2120_R01Dto[];
	setOriginalKSK2120_R01List: (list: KSK2120_R01Dto[]) => void;

    columnState: ColumnState[] | null;
    setColumnState: (state: ColumnState[] | null) => void;
		

	allCount: number;					setAllCount: (allCount: number) => void;

    initData: () => void;


}

export const defaultKSK2120_R01Filter: KSK2120_R01Filter = {
	// pastWorkNo: '',
	nowWorkNo: '',
	pastInfoFetch: 'N',
}

export const equipText = '장착필요'
export const collectText = '회수필요'

export const useKSK2120_R01Store = create<Store_KSK2120_R01>((set) => ({
	KSK2120_R01Filter: defaultKSK2120_R01Filter,
	KSK2120_R01PastFilter: defaultKSK2120_R01Filter,
	setKSK2120_R01PastFilter: (filter: Partial<KSK2120_R01Filter>) => set((state) => ({
		...state,
		KSK2120_R01PastFilter: { ...state.KSK2120_R01PastFilter, ...filter }
	})),
	setKSK2120_R01Filter: (filter: Partial<KSK2120_R01Filter>) => set((state) => ({
		...state,
		KSK2120_R01Filter: { ...state.KSK2120_R01Filter, ...filter }
	})),

    KSK2120_R01List: [],
    setKSK2120_R01List: (KSK2120_R01List: KSK2120_R01Dto[]) => set((state) => {
		let newList: KSK2120_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		KSK2120_R01List.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultKSK2120_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0,
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK2120_R01List: newList
		}
	}),
	insertKSK2120_R01List: (data: KSK2120_R01Dto[], index?: number) => set((state) => {
		let newKSK2120_R01List = [...state.KSK2120_R01List];

		// index 파라미터로 넘어온 값이 기준 행의 valueIndex입니다.
		let targetRowData = newKSK2120_R01List.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newKSK2120_R01List.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newKSK2120_R01List.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newKSK2120_R01List = newKSK2120_R01List.filter(item => item.orderIndex !== targetOrderIndex);
		newKSK2120_R01List.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => {
			// targetRowData가 있으면 해당 데이터를 기반으로 하되, lotNo와 lotQty는 초기화
			const baseData = targetRowData ? {
				...targetRowData,
				lotNo: '',
				lotQty: 0,
				remark: !validateString(targetRowData?.remark || '') ? equipText : targetRowData?.remark,
				inserted: true,
				isModified: false,
			} : defaultKSK2120_R01Dto;

			return { 
				...item,       // GridHandlerContent에서 넘어온 기본 데이터
				...baseData,   // 타겟 행에서 복사한 데이터를 덮어씌움 (이게 우선순위가 높아야 함)
				valueIndex: maxValueIndex++,
				orderIndex: targetOrderIndex,
				orderIndexSeq: newOrderIndexSeq
			};
		});
		if (index !== undefined) {
			newKSK2120_R01List.splice(index, 0, ...newData);
		} else {
			newKSK2120_R01List.push(...newData);
		}		

		return {
			...state,
			KSK2120_R01List: newKSK2120_R01List
		}
	}),
	removeKSK2120_R01List: (index: number) => set((state) => {
		console.log('removeKSK2120_R01List : ', index);
		const currentList = state.KSK2120_R01List;
		
		// 1. remark가 "" 이거나 "장착필요"인 행들을 모아서 그룹화
		const validRows = currentList.filter(item => item.remark === '' || item.remark === equipText);
		
		// 2. 고유한 자품목 정보 추출 (childItemcd 기준)
		const childItemGroupMap = new Map<string, KSK2120_R01Dto>();
		validRows.forEach(item => {
			if (!childItemGroupMap.has(item.childItemcd)) {
				childItemGroupMap.set(item.childItemcd, item);
			}
		});

		console.log('childItemGroupMap : ', childItemGroupMap);

		// 3. 인덱스에 해당하는 행 삭제
		const newKSK2120_R01List = currentList.filter((item) => item.valueIndex !== index);

		// 4. 삭제 후 리스트에 남아있는 childItemcd 목록
		const remainingChildItemCds = new Set(newKSK2120_R01List.map(item => item.childItemcd));

		// 5. 완전히 사라진 childItemcd가 있다면 빈 행("장착필요")으로 복구
		let maxValueIndex = Math.max(0, ...newKSK2120_R01List.map(item => item.valueIndex || 0));

		childItemGroupMap.forEach((groupInfo, childItemcd) => {
			if (!remainingChildItemCds.has(childItemcd)) {
				maxValueIndex++;
				
				const newEmptyRow: KSK2120_R01Dto = {
					...groupInfo, // 기존 행의 정보(productWorkNo, feederNo, itemNm 등) 유지
					valueIndex: maxValueIndex,
					// orderIndex와 orderIndexSeq를 그대로 유지하여 원래 위치에 생성되도록 함
					lotNo: '',
					itemCd: null as any,
					lotQty: 0,
					remark: equipText, // "장착필요"
					processType: "NOW",
					inserted: false,
					isModified: false,
				};
				
				newKSK2120_R01List.push(newEmptyRow);
			}
		});

		// 원래 순서를 유지하기 위해 재정렬
		newKSK2120_R01List.sort((a, b) => {
			if (a.orderIndex === b.orderIndex) {
				return a.orderIndexSeq - b.orderIndexSeq;
			}
			return a.orderIndex - b.orderIndex;
		});

		return {
			...state,
			KSK2120_R01List: newKSK2120_R01List
		}
	}),
	updateKSK2120_R01List: (valueIndex: number, data: KSK2120_R01Dto) => set((state) => {
		// 중복 체크 로직: childItemcd와 lotNo 쌍이 같은 행이 있는지 검사
		// 단, lotNo가 비어있는 경우는 중복 체크에서 제외하며, 자기 자신(동일한 valueIndex)도 제외
		if (data.childItemcd && data.lotNo && data.lotNo.trim() !== '') {
			const isDuplicate = state.KSK2120_R01List.some(
				item => item.valueIndex !== valueIndex && 
						item.childItemcd === data.childItemcd && 
						item.lotNo === data.lotNo
			);

			if (isDuplicate) {
				showWarning(`이미 등록된 자품목코드(${data.childItemcd})와 Lot No(${data.lotNo}) 조합입니다.`);
				// 중복일 경우 상태를 변경하지 않고 그대로 반환 (변경 취소)
				return state;
			}
		}

		if(data.lotQty < 0) {
			showWarning('수량은 0보다 작을 수 없습니다.');
			data.lotQty = 0;
		}

		// lotNo 값에 따라 remark 자동 설정
		if (!validateString(data.lotNo || '')) {
			data.remark = equipText;
		} else {
			data.remark = '';
		}

		const _KSK2120_R01List = state.KSK2120_R01List.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		
		return {
			...state,
			KSK2120_R01List: _KSK2120_R01List
		}
	}),

    deletedKSK2120_R01List: [],
    addDeletedKSK2120_R01List: (idList: string[]) => set((state) => {
        const _deletedUserList = [...state.deletedKSK2120_R01List];
		
		for(const valueIndex of idList) {
			const isInserted = state.KSK2120_R01List.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK2120_R01List.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedUserList.push(valueIndex);
			}
		}

        return {
            ...state,
            deletedKSK2120_R01List: _deletedUserList
        }
    }),
    removeDeletedKSK2120_R01List: (idList?: string[]) => set((state) => ({
        ...state,
        deletedKSK2120_R01List: [...state.deletedKSK2120_R01List].filter(value => idList ? !idList.includes(value) : false)
    })),

    selectedKSK2120_R01List: [],
	setSelectedKSK2120_R01List: (idList: string[]) => set({ selectedKSK2120_R01List: idList }),
	//add해도 set한거처럼 대체
    addSelectedKSK2120_R01List: (idList: string[]) => set((state) => {
        // const _selectedUserList = [...state.selectedKSK2120_R01List];
        // _selectedUserList.push(...(idList.filter(value => !_selectedUserList.includes(value))));
		const _selectedUserList = [...idList];

        return {
            ...state,
            selectedKSK2120_R01List: _selectedUserList
        }
    }),
    removeSelectedKSK2120_R01List: (idList?: string[]) => set((state) => ({
        ...state,
        selectedKSK2120_R01List: [...state.selectedKSK2120_R01List].filter(value => idList ? !idList.includes(value) : false)
    })),
	initSelectedKSK2120_R01List: () => set({ selectedKSK2120_R01List: [] }),
	allSelectedKSK2120_R01List: () => set((state) => ({
		selectedKSK2120_R01List: state.KSK2120_R01List.map(item => item.valueIndex.toString())
	})),

	originalKSK2120_R01List: [],
	
    setOriginalKSK2120_R01List: (KSK2120_R01List: KSK2120_R01Dto[]) => set((state) => {
		let newList: KSK2120_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		KSK2120_R01List.forEach((item, index) => {
			newList.push({ 
				...defaultKSK2120_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK2120_R01List: newList
		}
	}),

    columnState: null,
    setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	allCount: 0,				setAllCount: (allCount: number) => set({ allCount }),

    initData: () => set((state) => ({
        ...state,
		KSK2120_R01Filter: defaultKSK2120_R01Filter,
		KSK2120_R01PastFilter: defaultKSK2120_R01Filter,
		KSK2120_R01Info: undefined,
        KSK2120_R01List: [],
        selectedKSK2120_R01List: [],
        deletedKSK2120_R01List: [],
		allCount: 0
    }))
}));